import { handleActions } from 'redux-actions';
import { adminActionTypes } from '../actions';
import { createSuccessActionType } from '../helper';

const {
    GET_ROLE_LIST,
    GET_LIST_APP,
    GET_APP_ASSIGNED,

} = adminActionTypes;

const initialState = {
    roles: [],
    apps: [],
    appAssigned: [],
};

const admin = handleActions(
    {
        [createSuccessActionType(GET_ROLE_LIST)]: (state, action) => {
            return {
                ...state,
                roles: action.payload.data || [],
            };
        },
        [createSuccessActionType(GET_LIST_APP)]: (state, action) => {
            return {
                ...state,
                apps: action.payload.data || [],
            };
        },
        [createSuccessActionType(GET_APP_ASSIGNED)]: (state, action) => {
            return {
                ...state,
                appAssigned: action.payload.data || [],
            };
        },
    },
    initialState
);

export default admin;